module.exports = __webpack_public_path__ + "static/netflix_737x729-f9463feaf755acbc7be8219905639985.webp";